export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (imagePath.startsWith('data:')) return imagePath;
  if (imagePath.startsWith('http')) return imagePath;
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return imagePath;
  }
  return `http://localhost:5000${imagePath}`;
};

export const isImageSrc = (src) =>
  src?.startsWith('/') || src?.startsWith('data:') || src?.startsWith('http');
